// extracted by mini-css-extract-plugin
export default {"card":"Profile_card__Ad8UE","img":"Profile_img__eVwvh","icon":"Profile_icon__-7IBb","h1":"Profile_h1__k8nSt","p":"Profile_p__XPnVh"};